import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";

export const ScrollTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const up = () => {
    window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, y: 24, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.8 }}
          whileHover={{ y: -4 }}
          whileTap={{ scale: 0.9 }}
          transition={{ type: "spring", stiffness: 320, damping: 22 }}
          onClick={up}
          className="btn-glow fixed bottom-6 right-6 z-[70] rounded-full bg-[var(--surface2)] p-3.5 shadow-[0_10px_36px_rgba(0,0,0,0.35)]"
          aria-label="Volver al inicio"
          data-testid="scroll-top-button"
          data-cursor="cta"
        >
          <ArrowUp size={18} className="text-[var(--green)]" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
